import React, { useState, useEffect } from "react";
import Performances from "@/components/gallery/performances";
import { Shell } from "@/components/ui/shell";
import { useGalleryCtx } from "@/contexts/gallery";
import { Separator } from "../ui/separator";
import Winners from "./winners";
import Carpets from "./carpets";
import ExpandedView from "./expanded/expanded-view";
import { GalleryContentProps } from "./types/common";

export default function GalleryMain({ data }: GalleryContentProps) {
  const { currentGalleryItem, currentGalleryItems } = useGalleryCtx();
  const isExpandedView = currentGalleryItem !== null;

  const [scrollTarget, setScrollTarget] = useState<number | null>(null);

  const saveScrollPosition = () => {
    setScrollTarget(window.scrollY);
  };

  useEffect(() => {
    if (!isExpandedView && scrollTarget !== null) {
      window.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
      setScrollTarget(null);
    }
  }, [isExpandedView, scrollTarget]);

  return (
    <div>
      {isExpandedView ? (
        <Shell>
          <div className="py-10 lg:py-32">
            <ExpandedView items={currentGalleryItems} />
          </div>
        </Shell>
      ) : (
        <Shell>
          <div className="mt-20 flex min-h-screen flex-col gap-6 md:gap-12 lg:mt-32 lg:gap-20">
            <div onClick={saveScrollPosition}>
              <Performances data={data.performances} />
            </div>
            <Separator className="my-8 bg-secondary/40" />
            <div onClick={saveScrollPosition}>
              <Carpets data={data.lavender_carpet} />
            </div>
            <Separator className="my-8 bg-secondary/40" />
            <div onClick={saveScrollPosition}>
              <Winners data={data.winners_and_honoraries} />
            </div>
          </div>
        </Shell>
      )}
    </div>
  );
}
